import AuthPrimaryButton from "./AuthPrimaryButton";
import AuthTextField from "./AuthTextField";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { emailSchema } from "../../domain/validation/commonSchemas";
import { Link, useNavigate } from "react-router-dom";
import { useSendEmailOtp } from "../../application/hooks/useSendEmailOtp";
import {
  AUTH_FLOW_PURPOSE_KEY,
  AUTH_FLOW_PURPOSE_PASSWORD_RESET,
} from "../../domain/constants/authFlowConstants";
import { authTextButtonStyle } from "../theme/authTextButtonStyle";
const ForgotPasswordForm = () => {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const { sendEmailOtp, loading } = useSendEmailOtp();
  const navigate = useNavigate();

  const handleSubmit = async(e: React.FormEvent) => {
    e.preventDefault();
    const result = emailSchema.safeParse(email);
    if (!result.success) {
      setError(t(result.error.issues[0].message));
      return;
    }
    setError("");

    // Only continue to the OTP screen if the API accepted the email; show its
    // reason (e.g. unregistered email) under the field otherwise.
    try {
      await sendEmailOtp(email, AUTH_FLOW_PURPOSE_PASSWORD_RESET);
    } catch (err) {
      setError(
        err instanceof Error && err.message ? err.message : t("forgotPassword.sendError"),
      );
      return;
    }

    sessionStorage.setItem(AUTH_FLOW_PURPOSE_KEY, AUTH_FLOW_PURPOSE_PASSWORD_RESET);
    sessionStorage.setItem("user_email", email);
    navigate("/verify-email-otp", {
      state: { email, purpose: AUTH_FLOW_PURPOSE_PASSWORD_RESET },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6 w-full">
      <AuthTextField
        label={t("forgotPassword.emailLabel")}
        type="email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setError("");
        }}
        placeholder={t("forgotPassword.emailPlaceholder")}
        error={!!error}
        helperText={error}
      />
      <AuthPrimaryButton type="submit" loading={loading}>
        {t("forgotPassword.submit")}
      </AuthPrimaryButton>

      <Link
        to="/login"
        className="w-full text-center text-primary"
        style={authTextButtonStyle}
      >
        {t("forgotPassword.backToLogin")}
      </Link>
    </form>
  );
};

export default ForgotPasswordForm;